import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';
import Avatar from "../../../../../../../../../../../../components/avatar";
import Button from "../../../../../../../../../../../../components/button";
import Icon from "../../../../../../../../../../../../components/icon";
import CommentHeader from "./comment-header";
import CommentToEditAutoComplete from "./comment-to-edit-autocomplete";
import {
	commentContentToAdd,
	commentContentToEdit,
	editingComment,
	isLoadingCommentToEdit, parseContactOnCommentToEdit, showUpgradeToBusinessToComment,
	updateComment
} from '../../../../../../../../../../../../../actions/commentActions';
import {
    commentToEditContactSearchResult,
    resetCommentToEditContactSearchResult
} from "../../../../../../../../../../../../../actions/contactActions";
import './index.css';

function Comment (props) {

    const {
        isLoadingCommentToEdit,
        setIsLoadingCommentToEdit,
        editingComment,
        setEditingComment,
        updateComment,
        commentId,
	    commentPrivacy,
        sharingDetailsPopup,
        selectedContactsGroup,
        content,
        parseContactOnCommentToEdit,
        setParseContactOnCommentToEdit,
        commentContentToEdit,
        setCommentContentToEdit,
        setCommentToEditContactSearchResult,
        permission,
        authorName,
        timestamp,
	    updatedTimestamp,
        resetCommentToEditContactSearchResult,
        commentToEditContactSearchResult,
	    hasTheBusinessPermission,
	    showUpgradeToBusinessToComment,
	    commentContentToAdd,
	    setCommentContentToAdd,
        contactDetails,
        aiComment
    } = props;

    const [privateComment, setPrivateComment] = useState(permission);
    const { t } = useTranslation();

    useEffect(() => {
        if(parseContactOnCommentToEdit){
            setCommentToEditContactSearchResult(
                parseContactOnCommentToEdit[parseContactOnCommentToEdit.length - 1].substring(1),
                commentId
            );
        }
    }, [parseContactOnCommentToEdit, commentId, setCommentToEditContactSearchResult]);

    const cancelEditHandler = () => {
        resetCommentToEditContactSearchResult();
        setEditingComment(null);
        if(commentContentToAdd.length > 0){
	        setCommentContentToAdd("");
        }
        setCommentContentToEdit("");
    };

    const updateCommentHandler = () => {
        if(hasTheBusinessPermission){
	        setIsLoadingCommentToEdit(true);

	        let mentionsArray = commentContentToEdit.match(/@\w+\.?\w+@\w+\.\w+/g);
	        let mentionsArrayWithoutAt = [];

	        if(mentionsArray){
		        mentionsArrayWithoutAt = mentionsArray.map( item => (
			        item.substring(1)
		        ));
	        }

            if(sharingDetailsPopup.length > 0){
                updateComment(sharingDetailsPopup[2][0].id, commentId, selectedContactsGroup.id, {
                    "comment" : document.querySelector(`[data-comment-id="${commentId}"]`).value,
                    "permission" : privateComment,
                    "mentions": mentionsArrayWithoutAt
                });
            } else {
                updateComment(contactDetails.id, commentId, selectedContactsGroup.id, {
                    "comment" : document.querySelector(`[data-comment-id="${commentId}"]`).value,
                    "permission" : privateComment,
                    "mentions": mentionsArrayWithoutAt
                });
            }


        } else {
            showUpgradeToBusinessToComment(true);
        }
    };

    const changeHandler = (e) => {
        setCommentContentToEdit(e.currentTarget.value);
        setParseContactOnCommentToEdit(e.currentTarget.value.match(/@\w+$/g));
    };

    const privateCommentHandler = () => {

        if(privateComment === "PRIVATE"){
            setPrivateComment("PUBLIC");
        } else {
            setPrivateComment("PRIVATE");
        }

    };

    const formatEmails = text => {
        const regex = /(\w+\.?\w+@\w+\.\w+)/g;
        return text.replace(regex, '<a href="mailto:$1">$1</a>');
    };

	const multiLine = text => {
		const regex = /(\\n)/g;
		return text.replace(regex, '<br />');
	};

	const quoteRemoval = text => {
		const regex = /(")/g;
		return text.replace(regex, '');
	};

    return (
        <div className="comment d-flex">
            <Avatar
                className="mr-3"
                size={'2em'}
                src={props.avatar}
            />
            <div className="flex-grow-1">
                <CommentHeader
                    commentId={commentId}
                    commentPrivacy={commentPrivacy}
                    authorName={authorName}
                    timestamp={timestamp}
                    updatedTimestamp={updatedTimestamp}
                    aiComment={aiComment}
                />
	            <div className="d-flex align-items-center">
		            {commentPrivacy === 'PRIVATE' && !editingComment && <Icon className={"mr-3"} name={"eye-slash"}/>}
		            {
			            editingComment === commentId
				        ?
				            <div className="w-100">
					            <textarea
						            className="form-control mr-0"
						            name="edit_comment"
						            data-comment-id={commentId}
						            rows="1"
						            defaultValue={content}
						            onChange={changeHandler}
						            disabled={selectedContactsGroup.permission === 'READ_ONLY'}
					            />

					            { parseContactOnCommentToEdit && commentToEditContactSearchResult.length > 0 && <CommentToEditAutoComplete/> }

					            <div className="d-flex align-items-center justify-content-between w-100 my-3">
						            <div className="custom-control custom-checkbox mr-sm-2">
							            <input defaultChecked={permission === "PRIVATE"} disabled={selectedContactsGroup.permission === 'READ_ONLY'} onChange={privateCommentHandler} className="custom-control-input" type="checkbox" name={`private-comment-${commentId}`} id={`private-comment-${commentId}`}/>
							            <label htmlFor={`private-comment-${commentId}`} className="custom-control-label">{t("fieldPrivateComment")}</label>
						            </div>
						            {
							            isLoadingCommentToEdit
								            ?
								            <div>
									            <Button className="btn-primary font-weight-bold" disabled={true}>
										            <Icon animated={'pulse'} name="spinner"/>
									            </Button>
								            </div>
								            :
								            <div>
									            <Button className="btn-outline-primary mr-3" disabled={selectedContactsGroup.permission === 'READ_ONLY'} onClick={cancelEditHandler}>{t("textCancel")}</Button>
									            <Button className="btn-primary" disabled={selectedContactsGroup.permission === 'READ_ONLY'} onClick={updateCommentHandler}>{t("textComment")}</Button>
								            </div>
						            }
					            </div>
				            </div>
				        :
				            <div className="comment__content" dangerouslySetInnerHTML={{__html: formatEmails(multiLine(quoteRemoval(JSON.stringify(content)))) }} />
		            }
	            </div>

            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
    selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
    isLoadingCommentToEdit: state.commentReducer.isLoadingCommentToEdit,
    editingComment: state.commentReducer.editingComment,
    profile: state.profileReducer.getProfile,
    commentContentToEdit: state.commentReducer.commentContentToEdit,
    parseContactOnCommentToEdit: state.commentReducer.parseContactOnCommentToEdit,
    commentToEditContactSearchResult: state.contactReducer.commentToEditContactSearchResult,
	hasTheBusinessPermission: state.permissionReducer.hasTheBusinessPermission,
	commentContentToAdd: state.commentReducer.commentContentToAdd,
    contactDetails: state.contactDetailsReducer.findContactDetails
});

const mapDispatchToProps = (dispatch) => ({
    updateComment: (contactId, commentId, labelId, msgObj) => dispatch(updateComment(contactId, commentId, labelId, msgObj)),
    setIsLoadingCommentToEdit: (boolean) => dispatch(isLoadingCommentToEdit(boolean)),
    setEditingComment: (string) => dispatch(editingComment(string)),
    setCommentToEditContactSearchResult: (string, commentId) => dispatch(commentToEditContactSearchResult(string, commentId)),
    setParseContactOnCommentToEdit: (array) => dispatch(parseContactOnCommentToEdit(array)),
    setCommentContentToEdit: (string) => dispatch(commentContentToEdit(string)),
    resetCommentToEditContactSearchResult: () => dispatch(resetCommentToEditContactSearchResult()),
	showUpgradeToBusinessToComment: (boolean) => dispatch(showUpgradeToBusinessToComment(boolean)),
	setCommentContentToAdd: (string) => dispatch(commentContentToAdd(string)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Comment);
